import { render, staticRenderFns } from "./SuratJalan.vue?vue&type=template&id=2147ae9c&scoped=true"
import script from "./SuratJalan.vue?vue&type=script&lang=js"
export * from "./SuratJalan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147ae9c",
  null
  
)

export default component.exports